import React, { useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Input from '../Input';

interface SearchBoxProps {
  placeholder?: string;
  value?: string;
  onSearch?: (value: string) => void;
  style?: React.CSSProperties;
  debounceMs?: number;
}

const SearchBox: React.FC<SearchBoxProps> = ({ placeholder = 'Search', value = '', onSearch, style, debounceMs = 500 }) => {
  const [inputValue, setInputValue] = useState<string>(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch?.(inputValue);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [inputValue, onSearch, debounceMs]);

  const handleChange = (value: string) => {
    setInputValue(value);
  };

  return (
    <Input
      placeholder={placeholder}
      prefixIcon={<SearchOutlined />}
      value={inputValue}
      onChange={handleChange}
      theme="primary"
      style={{
        ...style,
      }}
    />
  );
};

export default SearchBox;

